import React from "react";
import { Button, Modal, Label, Checkbox } from "semantic-ui-react";
import moment from "moment";
import { getPatientHomeAddress } from "utils/address";
import { formatPhoneNumberToInternational } from "utils/phone";

const CompareMpiDataModal = ({
	open,
	close,
	mpiPatient,
	patient,
	mpiSelection,
	onChangeMpiSelection,
	cancelAutofillFromMpi,
	confirmAutofillFromMpi,
}) => {
	return (
		<Modal open={mpiPatient !== null}>
			<Modal.Header>Un patient avec ce numéro CNS a été trouvé dans l'annuaire national des patients.</Modal.Header>
			<Modal.Content>
				<div
					style={{
						color: "black",
						fontWeight: "bold",
						margin: "10px 0px",
					}}
				>
					Cochez les informations à mettre à jour pour ce patient.
				</div>
				<div style={{ fontSize: "larger", justifyContent: "center", display: "flex", width: "100%" }}>
					<span style={{ width: "170px" }}></span>
					<span style={{ width: "calc((100% - 230px)/2)", textAlign: "center" }}>
						<Label color="grey">MyLab</Label>
					</span>
					<span style={{ width: "calc((100% - 230px)/2)", textAlign: "center" }}>
						<Label color="orange">Annuaire national des patients</Label>
					</span>
				</div>

				<FormatedMpiField
					title="Genre"
					prop="gender"
					value={mpiPatient?.gender?.toLowerCase() === "m" ? "Homme" : "Femme"}
					selection={mpiSelection}
					onChange={onChangeMpiSelection}
					patient={patient}
					isRelevant={mpiPatient?.gender && mpiPatient?.gender?.toLowerCase() !== patient.gender}
				/>
				<FormatedMpiField
					title="Nom de naissance"
					prop="birth_name"
					value={mpiPatient?.birth_name}
					selection={mpiSelection}
					onChange={onChangeMpiSelection}
					patient={patient}
					isRelevant={mpiPatient?.birth_name && mpiPatient?.birth_name !== patient.birth_name}
				/>
				<FormatedMpiField
					title="Nom marital"
					prop="marital_name"
					value={mpiPatient?.marital_name}
					selection={mpiSelection}
					onChange={onChangeMpiSelection}
					patient={patient}
					isRelevant={mpiPatient?.marital_name && mpiPatient?.marital_name !== patient.marital_name}
				/>
				<FormatedMpiField
					title="Prénom(s)"
					prop="first_name"
					value={mpiPatient?.first_name}
					selection={mpiSelection}
					onChange={onChangeMpiSelection}
					patient={patient}
					isRelevant={mpiPatient?.first_name && mpiPatient?.first_name !== patient.first_name}
				/>
				<FormatedMpiField
					title="Date de naissance"
					prop="birth_date"
					value={mpiPatient?.birth_date ? moment(mpiPatient.birth_date.substring(0, 10)).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT) : null}
					selection={mpiSelection}
					onChange={onChangeMpiSelection}
					patient={patient}
					isRelevant={
						mpiPatient?.birth_date &&
						moment(mpiPatient.birth_date.substring(0, 10)).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT) !==
							moment(patient.birth_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)
					}
				/>
				<FormatedMpiField
					title="Téléphone"
					prop="phone"
					value={mpiPatient?.phone}
					selection={mpiSelection}
					onChange={onChangeMpiSelection}
					patient={patient}
					isRelevant={mpiPatient?.phone && mpiPatient?.phone !== patient.phone}
				/>
				<FormatedMpiField
					title="Téléphone mobile"
					prop="mobile_phone"
					value={mpiPatient?.mobile_phone}
					selection={mpiSelection}
					onChange={onChangeMpiSelection}
					patient={patient}
					isRelevant={mpiPatient?.mobile_phone && mpiPatient?.mobile_phone !== patient.mobile_phone}
				/>
				<FormatedMpiField
					title="Email"
					prop="email"
					value={mpiPatient?.email}
					selection={mpiSelection}
					onChange={onChangeMpiSelection}
					patient={patient}
					isRelevant={mpiPatient?.email && mpiPatient?.email !== patient.email}
				/>
				{mpiPatient?.address && (
					<FormatedMpiField
						title="Adresse"
						prop="address"
						value={`${mpiPatient.address.street} ${mpiPatient.address.complement} ${mpiPatient.address.postal_code} ${mpiPatient.address.city} ${mpiPatient.address.country}`}
						selection={mpiSelection}
						onChange={onChangeMpiSelection}
						patient={patient}
						isRelevant={
							mpiPatient.address &&
							`${mpiPatient.address.street} ${mpiPatient.address.complement} ${mpiPatient.address.postal_code} ${mpiPatient.address.city} ${mpiPatient.address.country}` !==
								getPatientHomeAddress(patient)
						}
					/>
				)}
			</Modal.Content>
			<Modal.Actions>
				<Button content="Annuler" color="red" onClick={cancelAutofillFromMpi} />
				<Button content="Mettre à jour" color="green" onClick={confirmAutofillFromMpi} />
			</Modal.Actions>
		</Modal>
	);
};

const FormatedMpiField = ({ title, value, prop, selection, onChange, patient, isRelevant }) => {
	return (
		<div style={{ fontSize: "larger", justifyContent: "center", display: "flex", width: "100%" }}>
			<span style={{ fontWeight: "bold", color: "black", width: "200px" }}>{title} : </span>

			<span style={{ fontStyle: "italic", color: "grey", width: "calc((100% - 230px)/2)" }}>
				{prop === "gender" && ((patient.gender === "m" && "Homme") || (patient.gender !== "m" && "Femme"))}
				{prop === "address" && getPatientHomeAddress(patient)}
				{prop === "phone" &&
					((patient.phone && formatPhoneNumberToInternational(patient.phone)) ||
						(!patient.phone && <span style={{ fontStyle: "italic", color: "grey" }}>/</span>))}
				{prop === "mobile_phone" &&
					((patient.mobile_phone && formatPhoneNumberToInternational(patient.mobile_phone)) ||
						(!patient.mobile_phone && <span style={{ fontStyle: "italic", color: "grey" }}>/</span>))}
				{prop === "birth_date" &&
					((patient.birth_date && moment(patient.birth_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)) ||
						(!patient.birth_date && <span style={{ fontStyle: "italic", color: "grey" }}>/</span>))}
				{prop !== "address" &&
					prop !== "birth_date" &&
					prop !== "gender" &&
					prop !== "phone" &&
					prop !== "mobile_phone" &&
					(patient[prop] || <span style={{ fontStyle: "italic", color: "grey" }}>/</span>)}
			</span>

			<span style={{ fontWeight: "bold", color: "black", width: "30px" }}>
				{isRelevant && (
					<Checkbox
						style={{ padding: "4px", marginRight: "10px" }}
						name={`check-` + title}
						checked={selection[prop]}
						onChange={() => onChange(prop)}
					/>
				)}
			</span>

			<span style={{ fontWeight: "bold", color: "black", width: "calc((100% - 230px)/2)", paddingRight: "20px" }}>
				{value && (prop === "phone" || prop === "mobile_phone") && `${formatPhoneNumberToInternational(value)}`}
				{value && prop !== "phone" && prop !== "mobile_phone" && value}
				{!value && <span style={{ fontStyle: "italic", color: "grey" }}>/</span>}
			</span>
		</div>
	);
};
export default CompareMpiDataModal;
